import { COUNTRIES } from '@wareclouds/frontend-common';

import { CONTEXT } from '@/config/consts/commons';
import env from '@/config/env';
import questionnaireBR from '../data/questionnaire-br';
import questionnaireCL from '../data/questionnaire-cl';

const DEFAULT_APPROVAL_RATE_THRESHOLD = 0.75;

const parsedApprovalRateThreshold = Number(
  env.ONBOARDING_APPROVAL_RATE_THRESHOLD
);
export const APPROVAL_RATE_THRESHOLD =
  Number.isFinite(parsedApprovalRateThreshold) &&
  parsedApprovalRateThreshold >= 0 &&
  parsedApprovalRateThreshold <= 1
    ? parsedApprovalRateThreshold
    : DEFAULT_APPROVAL_RATE_THRESHOLD;
export const APPROVAL_RATE_PERCENTAGE = Number(
  (APPROVAL_RATE_THRESHOLD * 100).toFixed(2)
);

export const TRAINING_VARIANTS = {
  BR: 'br',
  CL: 'cl',
};

const QUESTIONNAIRE_MAP = {
  [TRAINING_VARIANTS.BR]: questionnaireBR,
  [TRAINING_VARIANTS.CL]: questionnaireCL,
};

const TRAINING_SECTIONS = {
  [TRAINING_VARIANTS.BR]: [
    { id: 'what_is_wareclouds' },
    { id: 'about_being_clouder' },
    { id: 'pickup_and_delivery' },
    { id: 'returns' },
    { id: 'main_rules' },
  ],
  [TRAINING_VARIANTS.CL]: [
    { id: 'how_wareclouds_works' },
    { id: 'same_day_service' },
    { id: 'scheduled_express_service' },
    { id: 'deliveries_and_returns' },
    { id: 'rules_and_bonuses' },
  ],
};

export const getRawQuestionnaire = (variant) => QUESTIONNAIRE_MAP[variant];

export const getTrainingVariant = () => {
  if (CONTEXT === COUNTRIES.BR) return TRAINING_VARIANTS.BR;
  return TRAINING_VARIANTS.CL;
};

export const getTrainingSections = () =>
  TRAINING_SECTIONS[getTrainingVariant()];
